<template>
    <div>
        <span class="flex-shrink-0 inline-block relative">
          <img :src="avatarUrl()"
               alt=""
               class="h-10 w-10 rounded-full">
          <span :class="onlineClass" v-if="memberId" :key="isOnlineRenderKey"
                aria-hidden="true"
                class="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white"></span>
        </span>
        <slot name="default">
            <div class="ml-4 truncate flex-grow" v-if="memberName">
                <p class="text-xs font-medium text-gray-600 truncate">
                    <span v-text="memberName"></span>
                </p>
            </div>
            <div class="flex flex-shrink" v-if="removable">
                <span class="text-gray-300 fa fa-times pl-1 hover:text-red-500" @click="$emit('removed')"></span>
            </div>
        </slot>
    </div>
</template>

<script>
import UiDropdown from "../../ui/UiDropdown.vue";
import moment from "moment-timezone";

export default {
    components: {UiDropdown},
    props: {
        group: false,
        avatar: String | Boolean,
        memberId: String | Boolean,
        memberName: String | Boolean,
        contacts: [],
        removable: false,
    },
    data() {
        return {
            isOnlineRenderKey: 0,
            onlineClass: 'bg-gray-300',
        }
    },
    methods: {
        avatarUrl() {
            if (this.avatar) {
                return this.avatar
            }
            if (this.group) {
                return '/img/user-placeholder-multi.png'
            }
            return '/img/user-placeholder.png'
        },
        isOnlineClass(id) {
            if (!id) return '';
            let contact = this.contacts.find((i) => i.id === id);
            if (contact && contact.lastSeenAt) {
                let diff = Math.abs(moment(contact.lastSeenAt).diff(moment(), 'minutes'))
                if (diff < 2) {
                    return 'bg-green-400'
                } else if (diff < 10) {
                    return 'bg-orange-400'
                }
                return 'bg-gray-300'
            }
            return 'bg-gray-300'
        },
        updateTimer() {
            if (this.onlineClass !== this.isOnlineClass(this.memberId)) {
                this.onlineClass = this.isOnlineClass(this.memberId);
                this.isOnlineRenderKey++;
            }
            setTimeout(() => {
                this.updateTimer()
            }, 1000)
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOnlineRenderKey++;
        }, 10)

        this.updateTimer()
    },
}
</script>
